import React from "react";

const ApolloQuote = () => {
  return (
    <section className="apollo-quote">
      <div className="apollo-quote__image-column">
        <div className="apollo-quote__image-wrapper">
          <img
            className="apollo-quote__image"
            src="https://www.apollo.com/adobe/dynamicmedia/deliver/dm-aid--7ec21492-9a87-41c4-8781-2ed6bfe66ada/lca-featured-quote-banner.png?preferwebp=true&width=1200&quality=85"
            loading="lazy"
            width="480"
            height="388"
            alt="circles"
          />
        </div>
      </div>

      <div className="apollo-quote__content-column">
        <div className="apollo-quote__text-wrapper">
          <h5 className="apollo-quote__quote">
            “We encourage everyone at the firm to get involved with
            purpose-driven leadership in a way that feels personally authentic
            because it is a win-win-win: Our leaders grow, our firm impact
            expands, and our communities strengthen.”
          </h5>

          <p className="apollo-quote__attribution">
            <strong className="apollo-quote__name">
              Lauren Coape-Arnold
              <br />
            </strong>
            Global Head of Citizenship, Apollo Global Management, and Director
            of Apollo Opportunity Foundation
          </p>
        </div>
      </div>
    </section>
  );
};

export default ApolloQuote;
